// extracted by mini-css-extract-plugin
export default {"filterChip":"FilterChip_filterChip__NARY-","deleteIcon":"FilterChip_deleteIcon__IbQnq"};